<template>
  <div class="step-list-content">
    <div
      v-show="index === activeIndex"
      v-for="(step, index) in stepList"
      class="step"
      :key="index"
    >
      <slot :name="step.contentSlot" :step="step"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    stepList: {
      type: Array,
      required: true
    },
    activeIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
</style>
